<template>
    <div class="content-center" style="background-color: #000">
        <div class="p-7 flex justify-center items-center">
            <a href="/"><img src="/images/logo_testo.png" /></a>
        </div>
        <div class="pb-7 flex justify-center items-center">
            <div class="flex justify-center items-center bg-white rounded-md shadow overflow-hidden mx-5 max-w-2xl">
                <form @submit.prevent="store">
                    <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                        <div class="pr-6 pb-8 w-full lg:w-full">
                            <h2>Eliminazione account</h2>
                        </div>
                        <div class="pr-6 pb-8 w-full lg:w-full">
                            Per eliminare l'account, inserisci la tua mail qui sotto.
                        </div>
                        <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-full"
                            label="Email" />

                            <div class="pr-6 pb-8 w-full lg:w-full">
                            <input class="mr-1" type="checkbox" name="checkbox" id="checkbox" v-model="form.checkbox" />
                            Sono sicuro di voler eliminare l'account
                            <div class="form-error" v-if="form.errors.checkbox">{{ form.errors.checkbox }}</div>
                        </div>
                    </div>
                    <div class="mt-6 px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                        <loading-button :loading="form.processing" class="btn-indigo"
                            type="submit">Invia</loading-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo: { title: 'Street Stock' },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
    },
    // layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                email: null,
                checkbox: null,
            }),
        }
    },
    methods: {
        store() {
        },
    },
}
</script>